import { type Dispatch, type SetStateAction, useEffect, useState } from "react";

export function useDebouncedState<T>(defaultValue: T): [T, Dispatch<SetStateAction<T>>] {
  const [debouncedValue, setDebouncedValue] = useState<T>(defaultValue);
  const [value, setValue] = useState<T>(defaultValue);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedValue(value);
    }, 500);

    return () => clearTimeout(timeout);
  }, [value]);

  return [debouncedValue, setValue];
}
